import React, { useState, useEffect } from "react";
import Avatar from "apollo-react/components/Avatar";
import HeaderCustom from "../../common/Layout/Header";
import { getCurrentUser, logout } from '../services/authService';

const Header = () => {
  const [profileMenuProps, setProfileMenuProps] = useState({
    id: null,
    name: "",
    title: "",
    email: "",
    icon: null,
    logout: null,
    persona:null
  });

  useEffect(() => {
    const fetchProfileData = async () => {
      try {
        const response = await getCurrentUser();
        if (!response) return;
        
        const { id, username, role, email } = response.user;
        setProfileMenuProps({
          id: id,
          name: username,
          title: role?.name,
          email,
          icon: (
            <Avatar size="small" alt={username} stateless>
              {username
                .split(" ")
                .map((n) => n[0])
                .join("")}
            </Avatar>
          ),
          logout: logout,
          persona: 'user',
        });
      } catch (error) {
        console.error("Error fetching profile data:", error);
      }
    };

    fetchProfileData();
  }, []);

  // const profileMenuProps = {
  //   name: 'Olivia Queen',
  //   title: 'Sales Rep',
  //   email: 'olivia.queen@iqvia.com',
  //   icon: (
  //     <Avatar size="small" alt="Olivia Queen" stateless>
  //       OQ
  //     </Avatar>
  //   ),
  // }

  return <HeaderCustom profileMenuProps={profileMenuProps} />;
};

export default Header;
